// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__9g0_j","title":"hero_title__oBokF","results-message":"hero_results-message__hc6x5"};